import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  // ALWAYS use light mode for public-facing website to show golden velvet background
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    // Always apply light theme for the velvet background to show
    document.documentElement.setAttribute('data-theme', 'light');
    localStorage.setItem('cadence-theme', 'light');
  }, []);

  const toggleTheme = () => {
    // Theme toggle disabled for public pages - always light mode
    // setIsDarkMode(prev => !prev);
  };

  return (
    <ThemeContext.Provider value={{ isDarkMode, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
